import * as React from "react";
import { AlertMessage, AlertType, Form } from 'soprasteria-ui-library';
import { SearchPatientInput } from "./SearchPatientInput";
import "./SearchPatientForm.scss";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../App";
import { PatientApi } from "../../api/PatientApi";
import { setMessage } from "../../helpers/MessageHelper";

interface ISearchPatient {
    searchString: string;
}

interface ISearchPatientForm {
    customClass?: string;
}

export const SearchPatientForm: React.FunctionComponent<ISearchPatientForm> = ({ customClass }) => {
    const auth = useAuth();
    const api = new PatientApi(auth);
    const history = useHistory();
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const clearSearchPatientInputButtonId = "clear-search-patient-input";

    const onSubmit = (data: ISearchPatient) => {
        const trimmedValue = data.searchString.trim();
        
        api.getPatientGuidId(trimmedValue, (response) => {
            document.getElementById(clearSearchPatientInputButtonId)?.click();
            history.push(`/patient/${response}`);
        }, (error) => {
            const message = setMessage(error, errorMessage ?? "");
            setErrorMessage(message);
        });
    };

    return (
        <div className={`search-patient-form ${(customClass ?? "")}`} >
            <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
            <Form onSubmit={onSubmit}>
                <div className="form-inline" >
                    <SearchPatientInput name="searchString" required={true} label="Sök patient..." clearSearchPatientInputButtonId={clearSearchPatientInputButtonId} />
                </div>
            </Form>
        </div>
    );
}
